import { motion } from "framer-motion";
import { Map, Target, Crosshair } from "lucide-react";

const NIVELES = [
  {
    icon: Map,
    level: "Macro",
    title: "Rangos",
    desc: "Avanzas desde Recluta hasta Falcon en un camino estructurado. Cada ascenso desbloquea herramientas, indicadores y recompensas reales.",
  },
  {
    icon: Target,
    level: "Meso",
    title: "Misiones",
    desc: "Dentro de cada rango superas misiones: retos con evaluación práctica y objetivos de profit. Nada teórico sin ejecutar.",
  },
  {
    icon: Crosshair,
    level: "Micro",
    title: "Operaciones",
    desc: "Dentro de cada misión sigues un plan de operaciones con objetivos estratégicos y entregables con evidencia clara.",
  },
];

export default function ViajeLibertad() {
  return (
    <section className="relative py-24 md:py-32 bg-black overflow-hidden" data-testid="viaje-section">
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs font-display uppercase tracking-[0.4em] text-[#BEDD7D]">
            / El Viaje Honor
          </span>
          <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl uppercase tracking-tight leading-none">
            3 niveles de <span className="italic text-[#BEDD7D]">transformación</span>.
          </h2>
          <p className="mt-6 text-white/60 font-body">
            Un sistema entrenado para tu libertad mental, económica y temporal. Cada paso tiene
            reglas, objetivos y evidencia.
          </p>
        </div>

        <div className="relative grid md:grid-cols-3 gap-px bg-[#3E4D36]/30 border border-[#3E4D36]/40 rounded-3xl overflow-hidden">
          {NIVELES.map((n, i) => (
            <motion.div
              key={n.level}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              className="relative bg-black p-8 md:p-10 group"
              data-testid={`nivel-${n.level.toLowerCase()}`}
            >
              <div className="flex items-center justify-between mb-6">
                <div className="w-12 h-12 rounded-xl bg-[#1A2E1A] border border-[#BEDD7D]/30 flex items-center justify-center group-hover:border-[#BEDD7D] transition-colors">
                  <n.icon className="w-5 h-5 text-[#BEDD7D]" />
                </div>
                <span className="font-display font-bold text-5xl text-[#3E4D36] group-hover:text-[#BEDD7D]/50 transition-colors">
                  0{i + 1}
                </span>
              </div>
              <span className="text-[10px] font-display uppercase tracking-[0.3em] text-[#BEDD7D]">
                {n.level}
              </span>
              <h3 className="mt-2 font-display font-bold text-2xl md:text-3xl uppercase tracking-tight">
                {n.title}
              </h3>
              <p className="mt-4 text-white/70 font-body text-sm leading-relaxed">{n.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Liberty pillars */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { label: "Libertad Mental", desc: "Control emocional y disciplina operativa." },
            { label: "Libertad Económica", desc: "Ingresos del mercado + pool de rangos + comisiones." },
            { label: "Libertad Temporal", desc: "Opera cuando quieras desde cualquier parte del mundo." },
          ].map((p) => (
            <div
              key={p.label}
              className="p-6 rounded-2xl border border-[#3E4D36]/50 bg-[#1A2E1A]/30 hover:border-[#BEDD7D]/50 transition-colors"
              data-testid={`libertad-${p.label.toLowerCase().replace(/ /g, "-")}`}
            >
              <div className="text-xs font-display uppercase tracking-[0.3em] text-[#BEDD7D]">
                {p.label}
              </div>
              <div className="mt-3 text-white/80 font-body text-sm">{p.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
